export namespace SprintsHubTelemetryConstants {
    export const SPRINTS_REGISTRATION_LOAD_DIRECTORY = "SprintsRegistration_LoadSprintDirectory";
    export const ZERO_DATA_ADD_NEW_ITEM = "SprintsHub_Backlog_ZeroDataAddNewItem";
}
